jQuery(document).ready(function($) {

    var hamburger = $(".navbar_link-toggle");
    var menuItem = $(".menu-item");

    var width = $(window).outerWidth();



    if($('body').hasClass('wholesale_customer')){
      if(!$('#tab-description').children().length) {
        $("#tab-title-wholesale-delivery a").trigger('click');
      }
    }


    // Woocommerce Overwrites

    $('.additional_information_tab').removeClass('active');
    $('.other-information_tab').addClass('active');
    $('.woocommerce-Tabs-panel--other-information').css('display', 'block');

    $('button.question').click(function(event) {
      $(this).parent('.faq_single').toggleClass('open');
    });

    var review_slider = $('.review-carousel');
    review_slider.owlCarousel({
      items: 1,
      loop: true,
      autoplay: false,
      // autoplayTimeout: 3000,
      // autoplaySpeed: 2000,
      dots: true,
    });

    //Hamburger Toggle

    $(hamburger).click(function(e){
        if($('.mobile_div').hasClass('active')){
          $('.mobile_div').removeClass('active');
        } else {
          $('.mobile_div').addClass('active');
        }
        $('html').toggleClass('locked');
        $('body').toggleClass('locked');
        $('.hamburger').toggleClass("is-active");
        setTimeout(function(){
            $('.menu-item').toggleClass('active');
            $('.cart-contents').toggleClass('active');
        },500)
        e.preventDefault();
    });

    $(document).ready(function () {

      var owl = $('.hero_imageSlider');
      owl.owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 2000,
        dots: false,
      });

      // $('body').on('click touchstart', '.wc-pao-addon-image-swatch', function(event) {
      //   //event.preventDefault();
      //   if ($(this).data('value')) {
      //     var tinImage = $(this).find('img').attr('src');
      //     var tinImage = tinImage.replace("-150x150.", ".");
      //     console.log(tinImage);
      //     $('.woo-image-slider .owl-stage').append('<div class="owl-item"><a class="woo-gallery-popup" data-fancybox="gallery" href="'+tinImage+'"><img src="'+tinImage+'" alt="Tin Image"></a></div>');
      //     $('.woo-image-slider').trigger('destroy.owl.carousel');
      //     var wooImages = $('.woo-image-slider').owlCarousel({
      //       nav: true,
      //       dots: false,
      //       items: 1,
      //       autoHeight: true,
      //       navText: ['&lt;', '&gt;'],
      //     });
      //     wooImages.trigger('prev.owl.carousel');
      //   }
      // });
      //
      // var wooImages = $('.woo-image-slider').owlCarousel({
      //   nav: true,
      //   dots: false,
      //   items: 1,
      //   autoHeight: true,
      //   navText: ['&lt;', '&gt;'],
      // });
      //
      // var wooTrack = $('.woo-image-track').owlCarousel({
      //   nav: false,
      //   margin: 10,
      //   dots: false,
      //   loop: false,
      //   items: 6,
      //   stagePadding: 15,
      //   onTranslated: moveMainCarousel
      // });
      //
      // function moveMainCarousel(event) {
      //     var slide = event.item.index;
      //     wooImages.trigger('to.owl.carousel', slide);
      // }
      //
      // $('body').on('click', '.woo-gallery-trigger', function(event) {
      //   event.preventDefault();
      //   var slide = $(this).data('slide');
      //   wooTrack.trigger('to.owl.carousel', slide);
      //   wooImages.trigger('to.owl.carousel', slide);
      // });

    });

    $(document).ready(function () {

      var owl = $('.hero_slider');

      if(owl.children('.hero_slider__single').length > 1) {
        owl.owlCarousel({
          items: 1,
          loop: true,
          dots: false,
          autoplay: true,
          autoplayTimeout: 3000,
          animateIn: 'fadeIn',
          animateOut: 'fadeOut',
        });
      } else {
        owl.owlCarousel({
          items: 1,
          loop: false,
          dots: false,
        });
      }

      var owl = $('.product_slider_wrapper');
      if(owl.length) {
        owl.owlCarousel({
            items: 4,
            loop: true,
            margin: 40,
            autoplay: true,
            dots: false,
            slideTransition: 'linear',
            autoplayTimeout: 0,
            autoplaySpeed: 6000,
            autoplayHoverPause: true,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                },
                600:{
                    items:2,
                },
                960:{
                    items:4,
                }
            }
        });
      }

    });

    // In-View Toggle
    $(window).scroll( function() {
      inViewport();
    });
    $(window).resize( function() {
      inViewport();
    });
    function inViewport() {
      $('.view-wrapper').each(function() {
        var divPos = $(this).offset().top;
        var topOfWindow = $(window).scrollTop();
        if( $(window).width() < 960 ) {
          var offSet = ($(window).height());
        } else {
          var offSet = ($(window).height() / 4 * 3);
        }

        if( divPos < topOfWindow + offSet ) {
          $(this).addClass('in-view');
        }
      });
    }

    //IE 7-11 Object Fit Cover Polyfill
    if(navigator.userAgent.match(/Trident\/7\./)) {
    $('body').addClass('ie-user');

    $('.obj_fit_image').each(function () {
      var $container = $(this),
          imgUrl = $container.find('img').prop('src');
      if (imgUrl) {
        $container
          .css('backgroundImage', 'url(' + imgUrl + ')')
          .addClass('compat-object-fit');
      }
    });
    }

    //Get User Browser
    var browser = '';
    var browserVersion = 0;

    if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
      browser = 'opera';
    } else if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
      browser = 'ie';
    } else if (/Navigator[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
      browser = 'netscape';
    } else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
      browser = 'chrome';
    } else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
      browser = 'safari';
      /Version[\/\s](\d+\.\d+)/.test(navigator.userAgent);
      browserVersion = new Number(RegExp.$1);
    } else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
      browser = 'firefox';
    }
    if(browserVersion === 0){
      browserVersion = parseFloat(new Number(RegExp.$1));
    }
    $('body').addClass('browser_'+browser);


    $(window).scroll(function() {

      var scroll = $(window).scrollTop();
      $(".js-parallax-near").css("transform","translateY(" +  (scroll)/3  + "px)");
      $(".js-parallax-far").css("transform","translateY(-" +  (scroll)/4  + "px)");

      $(".js-parallax-norm").css("transform","translateY(" +  (scroll)/6  + "px)");

    });

//     if($('.single-product-main-image').length) {
//       var sliderWidth = $('.single-product-main-image').width();
//       $('.single-product-main-image').css('height', sliderWidth );
//       $('.single-product-main-image a img').css('height', sliderWidth );
//     }

    if ( document.getElementById('tab-title-description') || document.getElementById('tab-title-delivery') ) {
      return;
     } else {
       // Scroll to links
       $(document).on('click', 'a[href^="#"]', function (event) {
           var href = $(this).attr('href');
           if (!href || href === '#') {
             return;
           }
           var $target = $(href);
           if (!$target.length) {
             return;
           }
           event.preventDefault();

           $('html, body').animate({
               scrollTop: $target.offset().top -25 ,
           }, 500);
       });

       $(".scroll_arrow").click(function() {
           $('html, body').animate({
               scrollTop: $(this).parent().next(".modules").offset().top
           }, 500);
       });
     }

});




//@prepros-append ./vendor/custom.owl.carousel.js
//@prepros-append ./vendor/scrollreveal.min.js
